import { useState } from "react";

import { client } from "@/config/client";
import { useAppNotification } from "@/modules/app-notification";

import { handleExportSuccess, handleExportErrors } from "./importToolXSLX.util";

export const useExport = () => {
  const [loading, setLoading] = useState(false);
  const { notify } = useAppNotification();
  const handleExport = (model, params = {}) => {
    // keep only filters params
    const filters = Object.keys(params)
      .filter((param) => {
        return param.includes("filter") && !!params[param];
      })
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});

    setLoading(true);

    return client[model]
      .exports({ ...filters })
      .then(({ data }) => handleExportSuccess(data.data))
      .catch(({ response }) => handleExportErrors(response, notify))
      .finally(() => setLoading(false));
  };

  return { loading, handleExport };
};
